var _path, _path2, _path3, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlomeria({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_072-pipeline",
    "data-name": "072-pipeline",
    xmlns: "http://www.w3.org/2000/svg",
    width: 90.718,
    height: 92.525,
    viewBox: "0 0 90.718 92.525",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_200",
    "data-name": "Trazado 200",
    d: "M93.91,7.228H84.875a1.807,1.807,0,0,0-1.807,1.807v.9H77.646a1.806,1.806,0,0,0-1.579.93,30.757,30.757,0,0,0-29.5,30.695v1.807h-.9a1.807,1.807,0,0,0-1.807,1.807v7.228a1.807,1.807,0,0,0,1.807,1.807h.9V60.9a6.325,6.325,0,1,1-12.65,0V54.214h.9a1.807,1.807,0,0,0,1.807-1.807V45.178a1.807,1.807,0,0,0-1.807-1.807h-.9V19.635a1.8,1.8,0,0,0,.9-1.563V12.65h.9a1.807,1.807,0,0,0,1.807-1.807V1.807A1.807,1.807,0,0,0,35.721,0H6.807A1.807,1.807,0,0,0,5,1.807v9.036A1.807,1.807,0,0,0,6.807,12.65h.9v5.421a1.8,1.8,0,0,0,.9,1.563V43.371h-.9A1.807,1.807,0,0,0,5.9,45.178v7.228a1.807,1.807,0,0,0,1.807,1.807h.9V60.9a31.449,31.449,0,0,0,5.4,17.681A31.741,31.741,0,0,0,27.929,90.04a31.441,31.441,0,0,0,12.309,2.485v0A31.495,31.495,0,0,0,53.318,89.7a31.649,31.649,0,0,0,10.422-7.639,1.807,1.807,0,0,0-2.685-2.42A28.011,28.011,0,0,1,12.229,60.9V54.214H30.3V60.9a9.939,9.939,0,1,0,19.878,0V54.214H68.249V60.9a28.3,28.3,0,0,1-.488,5.233,1.813,1.813,0,0,0,1.778,2.143A1.808,1.808,0,0,0,71.312,66.8a31.9,31.9,0,0,0,.551-5.9V54.214h.9a1.807,1.807,0,0,0,1.807-1.807V45.178a1.807,1.807,0,0,0-1.807-1.807h-.9V41.925a5.793,5.793,0,0,1,4.341-5.6,1.8,1.8,0,0,0,1.442.721h5.421v.9a1.807,1.807,0,0,0,1.807,1.807H93.91a1.807,1.807,0,0,0,1.807-1.807V9.036A1.807,1.807,0,0,0,93.91,7.228ZM33.01,50.6H9.518V46.985H33.01ZM30.3,19.878V43.371H12.229V19.878ZM18.553,16.264V12.65h5.421v3.614Zm9.036,0V12.65H31.2v3.614Zm-12.65,0H11.325V12.65h3.614ZM8.614,9.036V3.614h25.3V9.036ZM70.96,50.6H47.467V46.985H70.96Zm4.879-17.9a9.413,9.413,0,0,0-7.59,9.223v1.446H50.178V41.564A27.142,27.142,0,0,1,75.839,14.5Zm7.228.729H79.453V29.818h3.614Zm0-7.228H79.453V20.782h3.614Zm0-9.036H79.453V13.553h3.614ZM92.1,36.142H86.682v-25.3H92.1Z",
    transform: "translate(-5)",
    fill: "#003082"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_201",
    "data-name": "Trazado 201",
    d: "M90.479,398.125a1.807,1.807,0,0,0-2.994,2.024,24.238,24.238,0,0,0,13.756,9.84,1.829,1.829,0,0,0,.472.063,1.808,1.808,0,0,0,.47-3.553A20.609,20.609,0,0,1,90.479,398.125Z",
    transform: "translate(-72.324 -325.528)",
    fill: "#86888b"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_202",
    "data-name": "Trazado 202",
    d: "M291.723,122.379a1.807,1.807,0,1,0,3.149,1.774c.184-.326.379-.651.581-.967a20.171,20.171,0,0,1,7.6-6.979,1.807,1.807,0,0,0-1.68-3.2,23.791,23.791,0,0,0-8.965,8.231C292.171,121.61,291.94,121.994,291.723,122.379Z",
    transform: "translate(-239.718 -92.414)",
    fill: "#86888b"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_1",
    "data-name": "Elipse 1",
    cx: 1.807,
    cy: 1.807,
    r: 1.807,
    transform: "translate(60.149 72.345)",
    fill: "#86888b"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlomeria);
export default __webpack_public_path__ + "static/media/plomeria.d1f03eb3df1067761fd593c160f35489.svg";
export { ForwardRef as ReactComponent };